var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"p-btn",attrs:{"data-cy":"add-theme-btn"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('icon',{attrs:{"name":"mdi.plus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }